module.exports = __webpack_public_path__ + "img/phone-pool.cafefd56.webp";